export default {
  'user': {
    'id': 0,
    'name': '',
    'email': '',
    'facebook_id': '',
    'phone': '',
    'localization': '',
    'token': '',
    'created_at': '',
    'updated_at': '',
    'type': 0,
    'active': 0,
    'secret': '',
    'terms': 0,
    'ios_device_token': '',
    'added_by_admin': 0,
    'parent_id': 0,
    'google_token': '',
    'google_email': '',
    'google_refresh_token': '',
    'google_calendar_id': '',
    'partner_id': 0
  },
  'company': {
    'id': 0,
    'user_id': 0,
    'package_id': 0,
    'package_valid_to': '',
    'title': '',
    'logo': '',
    'description': '',
    'address': '',
    'post_code': '',
    'city': '',
    'nip': '',
    'lat': '',
    'lng': '',
    'opening_hours_1': 0,
    'opening_hours_2': 0,
    'opening_hours_3': 0,
    'opening_hours_4': 0,
    'opening_hours_5': 0,
    'opening_hours_6': 0,
    'opening_hours_7': 0,
    'opening_hours_1_from': '',
    'opening_hours_2_from': '',
    'opening_hours_3_from': '',
    'opening_hours_4_from': '',
    'opening_hours_5_from': '',
    'opening_hours_6_from': '',
    'opening_hours_7_from': '',
    'opening_hours_1_to': '',
    'opening_hours_2_to': '',
    'opening_hours_3_to': '',
    'opening_hours_4_to': '',
    'opening_hours_5_to': '',
    'opening_hours_6_to': '',
    'opening_hours_7_to': '',
    'status': 0,
    'waiting_time': 0,
    'passes': 0,
    'phone': '',
    'email': '',
    'receive_notifications': 1,
    'www': '',
    'contact_person': 0,
    'created_at': '',
    'updated_at': '',
    'bookero_id': '',
    'api_key': '',
    'auto_rejection': 0,
    'auto_rejection_time': 0,
    'auto_email': 0,
    'require_mail': 0,
    'require_phone': 0,
    'people_required': 0,
    'msg_sent': '',
    'msg_confirmed': '',
    'msg_denied': '',
    'msg_waiting_list': '',
    'msg_email_confirmed': '',
    'msg_email_denied': '',
    'msg_email_free_term': '',
    'msg_email_canceled': '',
    'title_email_free_term': '',
    'title_email_canceled': '',
    'title_email_denied': '',
    'title_email_confirmed': '',
    'my_page': 0,
    'my_page_terms': '',
    'my_page_privacy_policy': '',
    'subdomain': '',
    'services': 0,
    'time_increaser': 0,
    'site_name': '',
    'site_show_menu': 0,
    'site_description': '',
    'site_keywords': '',
    'site_favicon': '',
    'ios_device_token': '',
    'sms': 0,
    'sms_counter': 0,
    'sms_can_cancel': 0,
    'sms_sender': '',
    'sms_sender_confirmed': 0,
    'sms_sender_to_confirm': 0,
    'sms_notification': '',
    'sms_cancel': '',
    'sms_send_before': 0,
    'sms_text_to_cancel': '',
    'send_sms_at_night': 0,
    'reservations_view': '',
    'auto_answer': 0,
    'payment': 0,
    'show_social_icons': 0,
    'social_facebook': '',
    'social_twitter': '',
    'social_linkedin': '',
    'social_pinterest': '',
    'social_google': '',
    'social_youtube': '',
    'social_instagram': '',
    'social_tripadvisor': '',
    'reservation_parameters': 0,
    'workers': 0,
    'google_calendar': 0,
    'service_name': '',
    'show_prices': 0,
    'own_domain': null,
    'rule_behavior': '',
    'helper_name': '',
    'waiting_list': 0,
    'auto_waiting_list': 0,
    'force_package_id': 0,
    'reservation_overtake': 0,
    'show_workers': 0,
    'invoice_data': 0,
    'invoice_title': '',
    'invoice_address': '',
    'invoice_city': '',
    'invoice_post_code': '',
    'invoice_nip': '',
    'sms_counter_notified': 0,
    'periodicity': 0,
    'default_periodicity': 0,
    'allow_change_periodicity': 0,
    'min_periodicity': 0,
    'max_periodicity': 0,
    'allow_change_max_periodicity': 0,
    'disable_periodicity_cancel': 0,
    'multilang': 0,
    'mail_reminder_send_before': 0,
    'mail_reminder_title': '',
    'mail_reminder_msg': '',
    'customers_based_on': '',
    'lockme_integration': 0,
    'znanylekarz_integration': 0,
    'attendances_list': 0,
    'auto_attendances': 0
  },
  'rodo': {
    'information_agree_text': '',
    'information_agree_url': '',
    'newsletter_agree': 0,
    'newsletter_agree_text': '',
    'privacy_policy_url': '',
    'show_information_agree': 0,
    'show_tp_agree': 0,
    'telemarketing_agree': 0,
    'telemarketing_agree_text': '',
    'terms_url': ''
  }
};



// WEBPACK FOOTER //
// ./src/store/default.state.config.js